<template>
	<div>
		<case-form :schema="schema" class="mt6" />
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
export default {
	components: {
		CaseForm
	},

	computed: {
		schema() {
			return [
				{
					label:
						"您是否政治家、政府官员、纪律部队人员、工会成员、司法人员、宗教组织成员或记者？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isPEPCN`,
					props: {
						suggest: {
							typeIncludes: `isPEPCN`
						},
						createOptions: {
							type: `isPEPCN`,
							dataType: "boolean"
						}
					}
				},
				{
					component: "html",
					props: {
						content:
							'<div class="xs-12 fs4 fw7 mb2 mt6">如果是，请提供详情</div>'
					}
				},
				{
					label: "职称",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPTitleCN`,
					props: {
						suggest: {
							typeIncludes: `PEPTitleCN`
						},
						createOptions: {
							type: `PEPTitleCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "职位等级",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPRankCN`,
					props: {
						suggest: {
							typeIncludes: `PEPRankCN`
						},
						createOptions: {
							type: `PEPRankCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "工作责任",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPDutiesCN`,
					props: {
						suggest: {
							typeIncludes: `PEPDutiesCN`
						},
						createOptions: {
							type: `PEPDutiesCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "如果否，请问您从事什么职业？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0occupationCN`,
					props: {
						suggest: {
							typeIncludes: `occupationCN`
						},
						createOptions: {
							type: `occupationCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `您是否有定期做运动？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasRegularExerciseCN`,
					props: {
						suggest: {
							typeIncludes: `hasRegularExerciseCN`
						},
						createOptions: {
							type: `hasRegularExerciseCN`,
							dataType: "boolean"
						}
					}
				},
				{
					component: "html",
					props: {
						content:
							'<div class="xs-12 fs4 fw7 mb2 mt6">如果是，请提供详情</div>'
					}
				},
				{
					label: "运动类型",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0exerciseTypeCN`,
					props: {
						suggest: {
							typeIncludes: `exerciseTypeCN`
						},
						createOptions: {
							type: `exerciseTypeCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "运动频率",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0exerciseFrequencyCN`,
					props: {
						suggest: {
							typeIncludes: `exerciseFrequencyCN`
						},
						createOptions: {
							type: `exerciseFrequencyCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "运动时间",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0exerciseDurationCN`,
					props: {
						suggest: {
							typeIncludes: `exerciseDurationCN`
						},
						createOptions: {
							type: `exerciseDurationCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `请问您曾否参与危险运动，如徒手潜水或水肺潜水、滑翔翼、高空跳伞、攀山及／或攀石、赛车或高速
赛艇或任何危险运动？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0participateInHazardousAvocationCN`,
					props: {
						suggest: {
							typeIncludes: `participateInHazardousAvocationCN`
						},
						createOptions: {
							type: `participateInHazardousAvocationCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `请问您曾否参与飞行活动，以乘客身分乘搭定期商业航班除外？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0participateInAviationActivitiesCN`,
					props: {
						suggest: {
							typeIncludes: `participateInAviationActivitiesCN`
						},
						createOptions: {
							type: `participateInAviationActivitiesCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "请问您曾否饮用含酒精饮料后驾驶",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasDrinkAndDriveCN`,
					props: {
						suggest: {
							typeIncludes: `hasDrinkAndDriveCN`
						},
						createOptions: {
							type: `hasDrinkAndDriveCN`,
							dataType: "boolean"
						}
					}
				},
				{
					component: "html",
					props: {
						content:
							'<div class="xs-12 fs4 fw7 mb2 mt6">如果是，请提供详情</div>'
					}
				},
				{
					label: "日期",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0drinkAndDriveDateCN`,
					props: {
						suggest: {
							typeIncludes: `drinkAndDriveDateCN`
						},
						createOptions: {
							type: `drinkAndDriveDateCN`,
							dataType: "date"
						}
					}
				},
				{
					label: "国家",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0drinkAndDriveCountryCN`,
					props: {
						suggest: {
							typeIncludes: `drinkAndDriveCountryCN`
						},
						createOptions: {
							type: `drinkAndDriveCountryCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "详情",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0drinkAndDriveDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `drinkAndDriveDetailCN`
						},
						createOptions: {
							type: `drinkAndDriveDetailCN`,
							dataType: "string"
						}
					}
				},
				{
					label:
						"请问您曾否因超速、不适当转弯、闯红灯或违反其他道路法规而被截停？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasMovingViolationCN`,
					props: {
						suggest: {
							typeIncludes: `hasMovingViolationCN`
						},
						createOptions: {
							type: `hasMovingViolationCN`,
							dataType: "boolean"
						}
					}
				},
				{
					component: "html",
					props: {
						content:
							'<div class="xs-12 fs4 fw7 mb2 mt6">如果是，请提供详情</div>'
					}
				},
				{
					label: "日期",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0movingViolationDateCN`,
					props: {
						suggest: {
							typeIncludes: `movingViolationDateCN`
						},
						createOptions: {
							type: `movingViolationDateCN`,
							dataType: "date"
						}
					}
				},
				{
					label: "国家",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0movingViolationCountryCN`,
					props: {
						suggest: {
							typeIncludes: `movingViolationCountryCN`
						},
						createOptions: {
							type: `movingViolationCountryCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "详情",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0movingViolationDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `movingViolationDetailsCN`
						},
						createOptions: {
							type: `movingViolationDetailsCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "请问您曾否因醉酒驾驶或其他不良驾驶行为而被检控？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasDrivingUnderInfluenceChargeCN`,
					props: {
						suggest: {
							typeIncludes: `hasDrivingUnderInfluenceChargeCN`
						},
						createOptions: {
							type: `hasDrivingUnderInfluenceChargeCN`,
							dataType: "boolean"
						}
					}
				},
				{
					component: "html",
					props: {
						content:
							'<div class="xs-12 fs4 fw7 mb2 mt6">如果是，请提供详情</div>'
					}
				},
				{
					label: "日期",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0drivingUnderInfluenceDateCN`,
					props: {
						suggest: {
							typeIncludes: `drivingUnderInfluenceDateCN`
						},
						createOptions: {
							type: `drivingUnderInfluenceDateCN`,
							dataType: "date"
						}
					}
				},
				{
					label: "国家",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0drivingUnderInfluenceCountryCN`,
					props: {
						suggest: {
							typeIncludes: `drivingUnderInfluenceCountryCN`
						},
						createOptions: {
							type: `drivingUnderInfluenceCountryCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "详情",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0drivingUnderInfluenceDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `drivingUnderInfluenceDetailsCN`
						},
						createOptions: {
							type: `drivingUnderInfluenceDetailsCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "请问您曾否因交通意外而被检控或吊销驾驶执照？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasMotorAccidentOrLicenseSuspendedCN`,
					props: {
						suggest: {
							typeIncludes: `hasMotorAccidentOrLicenseSuspendedCN`
						},
						createOptions: {
							type: `hasMotorAccidentOrLicenseSuspendedCN`,
							dataType: "boolean"
						}
					}
				},
				{
					component: "html",
					props: {
						content:
							'<div class="xs-12 fs4 fw7 mb2 mt6">如果是，请提供详情</div>'
					}
				},
				{
					label: "日期",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0motorAccidentDateCN`,
					props: {
						suggest: {
							typeIncludes: `motorAccidentDateCN`
						},
						createOptions: {
							type: `motorAccidentDateCN`,
							dataType: "date"
						}
					}
				},
				{
					label: "国家",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0motorAccidentCountryCN`,
					props: {
						suggest: {
							typeIncludes: `motorAccidentCountryCN`
						},
						createOptions: {
							type: `motorAccidentCountryCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "详情",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0motorAccidentDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `motorAccidentDetailsCN`
						},
						createOptions: {
							type: `motorAccidentDetailsCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `请问您曾否因犯刑事罪行而被定罪？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasBeenConvictedCN`,
					props: {
						suggest: {
							typeIncludes: `hasBeenConvictedCN`
						},
						createOptions: {
							type: `hasBeenConvictedCN`,
							dataType: "boolean"
						}
					}
				},
				{
					component: "html",
					props: {
						content:
							'<div class="xs-12 fs4 fw7 mb2 mt6">如果是，请提供详情</div>'
					}
				},
				{
					label: "日期",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0convictionDateCN`,
					props: {
						suggest: {
							typeIncludes: `convictionDateCN`
						},
						createOptions: {
							type: `convictionDateCN`,
							dataType: "date"
						}
					}
				},
				{
					label: "国家",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0convictionCountryCN`,
					props: {
						suggest: {
							typeIncludes: `convictionCountryCN`
						},
						createOptions: {
							type: `convictionCountryCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "详情",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0convictionDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `convictionDetailsCN`
						},
						createOptions: {
							type: `convictionDetailsCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `请问您曾否因交通意外而被检控或吊销驾驶执照？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasBeenConvictedOfRecklessDrivingInPast10YearsCN`,
					props: {
						suggest: {
							typeIncludes: `hasBeenConvictedOfRecklessDrivingInPast10YearsCN`
						},
						createOptions: {
							type: `hasBeenConvictedOfRecklessDrivingInPast10YearsCN`,
							dataType: "boolean"
						}
					}
				},
				{
					component: "html",
					props: {
						content:
							'<div class="xs-12 fs4 fw7 mb2 mt6">如果是，请提供详情</div>'
					}
				},
				{
					label: "日期",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0recklessDrivingDateCN`,
					props: {
						suggest: {
							typeIncludes: `recklessDrivingDateCN`
						},
						createOptions: {
							type: `recklessDrivingDateCN`,
							dataType: "date"
						}
					}
				},
				{
					label: "国家",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0recklessDrivingCountryCN`,
					props: {
						suggest: {
							typeIncludes: `recklessDrivingCountryCN`
						},
						createOptions: {
							type: `recklessDrivingCountryCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "详情",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0recklessDrivingDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `recklessDrivingDetailsCN`
						},
						createOptions: {
							type: `recklessDrivingDetailsCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `您是否因车祸而判刑？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasBeenConvictedOfAutoMobileAccidentCN`,
					props: {
						suggest: {
							typeIncludes: `hasBeenConvictedOfAutoMobileAccidentCN`
						},
						createOptions: {
							type: `hasBeenConvictedOfAutoMobileAccidentCN`,
							dataType: "boolean"
						}
					}
				},
				{
					component: "html",
					props: {
						content:
							'<div class="xs-12 fs4 fw7 mb2 mt6">如果是，请提供详情</div>'
					}
				},
				{
					label: "日期",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0automobileAccidentDateCN`,
					props: {
						suggest: {
							typeIncludes: `automobileAccidentDateCN`
						},
						createOptions: {
							type: `automobileAccidentDateCN`,
							dataType: "date"
						}
					}
				},
				{
					label: "国家",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0automobileAccidentCountryCN`,
					props: {
						suggest: {
							typeIncludes: `automobileAccidentCountryCN`
						},
						createOptions: {
							type: `automobileAccidentCountryCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "详情",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0automobileAccidentDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `automobileAccidentDetailsCN`
						},
						createOptions: {
							type: `automobileAccidentDetailsCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `您是否曾被指控或被判决犯罪，或您当前有没有处于缓刑，假释或法定释放？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasPendingChargesOrCriminalHistoryCN`,
					props: {
						suggest: {
							typeIncludes: `hasPendingChargesOrCriminalHistoryCN`
						},
						createOptions: {
							type: `hasPendingChargesOrCriminalHistoryCN`,
							dataType: "boolean"
						}
					}
				},
				{
					component: "html",
					props: {
						content:
							'<div class="xs-12 fs4 fw7 mb2 mt6">如果是，请提供详情</div>'
					}
				},
				{
					label: "日期",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0pendingChargesDateCN`,
					props: {
						suggest: {
							typeIncludes: `pendingChargesDateCN`
						},
						createOptions: {
							type: `pendingChargesDateCN`,
							dataType: "date"
						}
					}
				},
				{
					label: "国家",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0pendingChargesCountryCN`,
					props: {
						suggest: {
							typeIncludes: `pendingChargesCountryCN`
						},
						createOptions: {
							type: `pendingChargesCountryCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "详情",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0pendingChargesDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `pendingChargesDetailsCN`
						},
						createOptions: {
							type: `pendingChargesDetailsCN`,
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
